import _ from 'lodash'
import {listToMap, parseItem} from '@/utils/media'
import {IDataSource} from '.'
import pako from 'pako'

const decodeResponse = async (response: Response) => {
  if (!response.ok) throw new Error('failed to fetch catalog')

  const compressedData = await response.arrayBuffer()
  let responseText

  const contentDisposition = response.headers.get('content-disposition')
  if (contentDisposition && contentDisposition.includes('.gz')) {
    responseText = pako.ungzip(new Uint8Array(compressedData), {to: 'string'})
  } else {
    responseText = new TextDecoder().decode(compressedData)
  }

  const res = _.chain(_.split(responseText, '\n'))
    .compact()
    .map((v) => {
      try {
        return parseItem(JSON.parse(v))
      } catch (_error) {
        console.error('invalid json line:', v)
      }
    })
    .compact()
    .value()
  return listToMap(res)
}

export function catalogSource<T extends {catalogName: string}>(args: T): IDataSource<T> {
  const {catalogName} = args

  return {
    sourceID: 'catalog',
    key: catalogName,
    args,
    fetch: async () => {
      const loadCatalogUrl = `/api/gfp-result/load-catalog?catalog=${encodeURIComponent(catalogName)}`
      const [response, responseEpisodes] = await Promise.all([
        fetch(loadCatalogUrl).then(decodeResponse),
        fetch(`${loadCatalogUrl}&episodes=true`).then(decodeResponse),
      ])
      return _.merge(response, responseEpisodes)
    },
  }
}
